import type { GroupedItems, GroupingConfig, RemainingItem } from './types';
const DEFAULT_TASK_LEVEL_OBJECT_TYPES = new Set(['task', 'task questionnaire']);
export const isTaskLevelItem = (item: RemainingItem, config?: GroupingConfig): boolean => {
  const taskTypes = config?.taskLevelObjectTypes ?? DEFAULT_TASK_LEVEL_OBJECT_TYPES;
  return taskTypes.has(item.objectType);
};
export const getTagLabel = (item: RemainingItem, config?: GroupingConfig): string => {
  if (item.tagLabel) {
    return item.tagLabel;
  }
  if (item.groupingKey) {
    const isTaskLevel = isTaskLevelItem(item, config);
    const customMap = isTaskLevel ? config?.taskLevelTagMap : config?.tagMap;
    const mappedLabel = customMap?.[item.groupingKey];
    if (mappedLabel) {
      return mappedLabel;
    }
  }
  return item.label;
};
export const groupItems = (items: RemainingItem[], config?: GroupingConfig): GroupedItems[] => {
  const taskGroupLabel = config?.taskGroupLabel ?? 'Task';
  const groupMap = new Map<string, GroupedItems>();
  const groupOrder: string[] = [];
  for (const item of items) {
    const isTask = isTaskLevelItem(item, config);
    const groupKey = isTask ? 'task' : item.label;
    const groupLabel = isTask ? taskGroupLabel : item.label;
    if (!groupMap.has(groupKey)) {
      groupOrder.push(groupKey);
      groupMap.set(groupKey, {
        groupKey,
        groupLabel,
        itemCount: 0,
        items: [],
        tagColor: item.tagColor,
        objectType: item.objectType
      });
    }
    const group = groupMap.get(groupKey)!;
    group.items.push(item);
    group.itemCount = group.items.length;
  }
  return groupOrder.map(key => groupMap.get(key)!);
};
export const splitItems = (items: RemainingItem[]): {
  pendingItems: RemainingItem[];
  errorItems: RemainingItem[];
} => {
  const pendingItems = items.filter(item => item.category === 'pending');
  const errorItems = items.filter(item => item.category === 'error');
  return {
    pendingItems,
    errorItems
  };
};